export default "__VITE_ASSET__BNKknrR4__"